import './index.css';

export default function Button({ label = 'Botón'}){
    return (
        <button className="btn-button-comun">{ label }</button>
    );
}